webpackJsonp([7622844026085],{

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.ProductStoreCard = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(55);
	
	var _reactSlick = __webpack_require__(62);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _reactFacebookPixel = __webpack_require__(32);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _RestrictedStateWiseComponent = __webpack_require__(85);
	
	var _RestrictedStateWiseComponent2 = _interopRequireDefault(_RestrictedStateWiseComponent);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactRedux = __webpack_require__(78);
	
	__webpack_require__(634);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PackType = {
	  0: "Mini Pouch",
	  1: "Carton",
	  2: "Pouch",
	  3: "Incense sticks",
	  4: "Pack"
	};
	
	var settings = {
	  dots: false,
	  infinite: true,
	  speed: 500,
	  slidesToShow: 1,
	  slidesToScroll: 1
	};
	var WeightAndPriceDropdown = function WeightAndPriceDropdown(_ref) {
	  var title = _ref.title,
	      items = _ref.items,
	      handleWtList = _ref.handleWtList,
	      activeKey = _ref.activeKey;
	
	  return _react2.default.createElement(
	    _reactBootstrap.DropdownButton,
	    { id: title, bsStyle: "default", title: "" + title },
	    items.map(function (item, i) {
	      return _react2.default.createElement(
	        _reactBootstrap.MenuItem,
	        {
	          onClick: function onClick() {
	            return handleWtList(item);
	          },
	          active: activeKey === item.id,
	          key: i,
	          eventKey: i
	        },
	        item.netWeight,
	        " ",
	        PackType[item.packType],
	        " at Rs. ",
	        item.mrp
	      );
	    })
	  );
	};
	
	WeightAndPriceDropdown.propTypes = {
	  title: _propTypes2.default.string,
	  items: _propTypes2.default.array,
	  handleWtList: _propTypes2.default.func,
	  activeKey: _propTypes2.default.number,
	  cartChange: _propTypes2.default.bool
	};
	
	var ProductStoreCard = exports.ProductStoreCard = function (_React$Component) {
	  _inherits(ProductStoreCard, _React$Component);
	
	  function ProductStoreCard(args) {
	    _classCallCheck(this, ProductStoreCard);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _initialiseProps.call(_this);
	
	    var product = _this.props.product;
	
	    _this.state = {
	      qty: product.qty || 1,
	      added: product.qty > 0,
	      lastCounter: 30,
	      activeWtList: {},
	      activeKey: product.id,
	      isFetching: true
	    };
	    return _this;
	  }
	
	  ProductStoreCard.prototype.componentDidMount = function componentDidMount() {
	    var _props = this.props,
	        location = _props.location,
	        product = _props.product,
	        addToCartList = _props.addToCartList;
	
	    this.setTheInitialValues(product, addToCartList);
	    _reactFacebookPixel2.default.init("145006083100066");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	  };
	
	  ProductStoreCard.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    // this.setState({
	    // 	isLoading: true
	    // })
	    // console.log("nextProps", nextProps)
	    if (nextProps.product.qty !== this.props.product.qty) {
	      var product = nextProps.product;
	      // console.log("nextProps", nextProps)
	
	      this.setTheInitialValues(product, nextProps.addToCartList);
	    }
	  };
	
	  ProductStoreCard.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props2 = this.props,
	        region = _props2.region,
	        listItemById = _props2.listItemById;
	    var _state = this.state,
	        activeKey = _state.activeKey,
	        activeWtList = _state.activeWtList,
	        isFetching = _state.isFetching;
	
	    if (isFetching) {
	      return null;
	    }
	    var product = activeWtList;
	    var imgUrl = activeWtList.imgUrls.length ? activeWtList.imgUrls[0] : null;
	    var wtLabel = activeWtList.netWeight + " " + PackType[activeWtList.packType] + " at Rs " + activeWtList.mrp;
	    return _react2.default.createElement(
	      "div",
	      { className: "card product__card__wrapper" },
	      _react2.default.createElement(
	        "div",
	        { className: "slider__content" },
	        _react2.default.createElement(
	          _reactSlick2.default,
	          settings,
	          product.imgUrls.map(function (item, i) {
	            return _react2.default.createElement(
	              "div",
	              { key: i, className: "slider__img" },
	              _react2.default.createElement("img", {
	                src: item,
	                alt: product.productName,
	                className: "img img-responsive"
	              })
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "media", style: { margin: "0" } },
	        _react2.default.createElement(
	          "a",
	          {
	            style: { textDecoration: "none", color: "" },
	            href: "/products/Detail?" + product.type + "&" + product.urlName.replace(/ /g, "-")
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "card__title" },
	            product.productName
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-xs-5 weight__list", style: { textAlign: "left" } },
	          _react2.default.createElement(
	            _reactBootstrap.ButtonToolbar,
	            null,
	            _react2.default.createElement(WeightAndPriceDropdown, {
	              handleWtList: this.handleWtList,
	              activeKey: activeKey,
	              title: wtLabel,
	              items: this.weightList
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-xs-5 pull-right", style: { textAlign: "right" } },
	          _react2.default.createElement(
	            "div",
	            { className: "card__qty" },
	            "Price"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "card__price" },
	            _react2.default.createElement("i", { className: "fa fa-inr", "aria-hidden": "true" }),
	            " ",
	            product.mrp
	          )
	        )
	      ),
	      product.type !== "Dhoop" ? _react2.default.createElement(
	        _RestrictedStateWiseComponent2.default,
	        { regionName: region },
	        _react2.default.createElement(
	          "div",
	          { className: "row", style: { marginTop: "10px" } },
	          _react2.default.createElement(
	            "div",
	            { className: "col-xs-4 col-md-6" },
	            _react2.default.createElement(
	              "div",
	              { className: "input-group qty" },
	              _react2.default.createElement(
	                "span",
	                { className: "input-group-btn" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    onClick: function onClick() {
	                      return _this2.handleQuantity("sub");
	                    },
	                    type: "button",
	                    className: "quantity-left-minus btn btn-default btn-number",
	                    "data-type": "minus",
	                    "data-field": ""
	                  },
	                  _react2.default.createElement("span", { className: "glyphicon glyphicon-minus" })
	                )
	              ),
	              _react2.default.createElement("input", {
	                readOnly: true,
	                type: "text",
	                id: "quantity",
	                name: "quantity",
	                className: "form-control input-number",
	                value: product.qty || 1,
	                min: "1",
	                max: "100"
	              }),
	              _react2.default.createElement(
	                "span",
	                { className: "input-group-btn" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    onClick: function onClick() {
	                      return _this2.handleQuantity("add");
	                    },
	                    type: "button",
	                    className: "quantity-right-plus btn btn-default btn-number",
	                    "data-type": "plus",
	                    "data-field": ""
	                  },
	                  _react2.default.createElement("span", { className: "glyphicon glyphicon-plus" })
	                )
	              )
	            )
	          )
	        )
	      ) : null,
	      _react2.default.createElement(
	        "a",
	        {
	          href: "/products/Detail?" + product.type + "&" + product.urlName.replace(/ /g, "-"),
	          className: "view-btn"
	        },
	        "View"
	      )
	    );
	  };
	
	  return ProductStoreCard;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.setTheInitialValues = function (product, addToCartList) {
	    var uniqueProductItems = _this3.props.uniqueProductItems;
	
	    _this3.weightList = [];
	    var activeKey = _this3.state.activeKey;
	    // addToCartList = addToCartList.products
	    // console.log("activeKey", addToCartList)
	    // let index
	
	    uniqueProductItems.map(function (item, i) {
	      // if (item.u_id === activeKey) {
	      // 	index = i
	      // }
	
	      _this3.weightList.push(_extends({}, item, {
	        qty: addToCartList[item.id] ? addToCartList[item.id].qty || 1 : 1,
	        added: addToCartList[item.id] ? addToCartList[item.id].qty > 0 : false
	      }));
	    });
	    _this3.setState({
	      activeWtList: _extends({}, product, {
	        qty: addToCartList[product.id] ? addToCartList[product.id].qty : 1,
	        added: addToCartList[product.id] ? addToCartList[product.id].qty > 0 : false
	      }),
	      activeKey: _this3.state.activeKey || product.id,
	      change: !_this3.state.change,
	      isFetching: false
	    });
	  };
	
	  this.handleQuantity = function (fn) {
	    var _state2 = _this3.state,
	        activeKey = _state2.activeKey,
	        activeWtList = _state2.activeWtList;
	
	    var activeIndex = void 0;
	    _this3.weightList.map(function (item, i) {
	      if (activeKey === item.id) {
	        activeIndex = i;
	      }
	    });
	    if (fn === "add") {
	      activeWtList.qty = activeWtList.qty + 1;
	      // activeWtList.added = true
	    } else {
	      if (activeWtList.qty - 1 >= 0) {
	        activeWtList.qty = activeWtList.qty - 1;
	      }
	      if (activeWtList.qty === 0) {
	        activeWtList.added = false;
	      }
	    }
	    activeWtList.added = false;
	    _this3.weightList[activeIndex] = activeWtList;
	    _this3.setState({
	      activeWtList: activeWtList
	    });
	  };
	
	  this.addToCart = function () {
	    var _extends2;
	
	    var _props3 = _this3.props,
	        product = _props3.product,
	        setToCart = _props3.setToCart;
	    var _state3 = _this3.state,
	        qty = _state3.qty,
	        activeKey = _state3.activeKey,
	        activeWtList = _state3.activeWtList;
	    // window.localStorage.setItem("cart", {})
	
	    var cart = JSON.parse(localStorage.getItem("cart"));
	    var activeIndex = void 0;
	    _this3.weightList.map(function (item, i) {
	      if (item.id === activeKey) {
	        activeIndex = i;
	        _this3.weightList[i].added = true;
	      }
	    });
	    var addedProduct = _extends({}, activeWtList);
	    if (!cart) {
	      cart = {
	        products: {},
	        totalNumber: 0
	      };
	    }
	    var totalNumber = 1;
	    var bucket = {
	      products: _extends({}, cart.products, (_extends2 = {}, _extends2[addedProduct.id] = addedProduct, _extends2)),
	      totalNumber: totalNumber
	    };
	    localStorage.setItem("cart", JSON.stringify(bucket));
	    setToCart(bucket);
	  };
	
	  this.handleWtList = function (item) {
	    // console.log("tiem,", item)
	    _this3.setState({
	      activeWtList: item,
	      activeKey: item.id
	    });
	  };
	};
	
	ProductStoreCard.propTypes = {
	  product: _propTypes2.default.object,
	  setToCart: _propTypes2.default.func,
	  isCartChange: _propTypes2.default.bool,
	  uniqueProductItems: _propTypes2.default.object
	};
	var mapStateToPropsView = function mapStateToPropsView(state, ownProps) {
	  var product = ownProps.product;
	
	  return _extends({}, ownProps, {
	    product: state.addToCartList.products[product.id] || product,
	    region: state.ipData.region || "delhi",
	    uniqueProductItems: state.products.uIdListItemById[product.u_id] || [],
	    listItemById: state.products.listItemById,
	    isCartChange: state.addToCartList.isAddToCartChange,
	    addToCartList: state.addToCartList.products
	    // region: "XYX"
	  });
	};
	
	var mapDispatchToPropsView = function mapDispatchToPropsView(dispatch) {
	  return {
	    setToCart: function setToCart(bucket) {
	      return dispatch({ type: "SET_TO_CART", addToCartList: bucket });
	    }
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToPropsView, mapDispatchToPropsView)(ProductStoreCard);

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.RestrictedStateWiseComponent = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _restrictedStates = __webpack_require__(86);
	
	var _restrictedStates2 = _interopRequireDefault(_restrictedStates);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RestrictedStateWiseComponent = exports.RestrictedStateWiseComponent = function (_React$Component) {
		_inherits(RestrictedStateWiseComponent, _React$Component);
	
		function RestrictedStateWiseComponent() {
			_classCallCheck(this, RestrictedStateWiseComponent);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		RestrictedStateWiseComponent.prototype.render = function render() {
			var _props = this.props,
			    children = _props.children,
			    regionName = _props.regionName;
	
			if (_restrictedStates2.default.indexOf(regionName.toLowerCase()) >= 0) {
				return null;
			} else return children;
		};
	
		return RestrictedStateWiseComponent;
	}(_react2.default.Component);
	
	RestrictedStateWiseComponent.propTypes = {
		children: _propTypes2.default.node,
		regionName: _propTypes2.default.string
	};
	
	exports.default = RestrictedStateWiseComponent;

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var resStates = ["delhi", "uttar pradesh", "haryana", "punjab", "chandigarh", "national capital territory of delhi", "new delhi", "uttarakhand"];
	
	exports.default = resStates;
	module.exports = exports["default"];

/***/ }),

/***/ 634:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 637:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.View = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(637);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSlick = __webpack_require__(62);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(169);
	
	__webpack_require__(168);
	
	var _reactSpinners = __webpack_require__(144);
	
	var _productListConstant = __webpack_require__(42);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactRedux = __webpack_require__(78);
	
	var _contentPage = __webpack_require__(19);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(20);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _RestrictedStateWiseComponent = __webpack_require__(85);
	
	var _RestrictedStateWiseComponent2 = _interopRequireDefault(_RestrictedStateWiseComponent);
	
	var _reactFacebookPixel = __webpack_require__(32);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _ProductStoreCard = __webpack_require__(451);
	
	var _ProductStoreCard2 = _interopRequireDefault(_ProductStoreCard);
	
	var _reactBootstrap = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { push } from "react-router-redux"
	// import qs from "qs"
	// import Heading from "components/Heading"
	
	
	var settings = {
	  dots: false,
	  infinite: true,
	  speed: 500,
	  slidesToShow: 1,
	  slidesToScroll: 1
	};
	var duration = 300;
	// export class ProductStoreCard extends React.Component {
	// 	constructor (args) {
	// 		super(args)
	// 		const { product } = this.props
	// 		this.state = {
	// 			qty: product.qty || 1,
	// 			added: product.qty > 0,
	// 			lastCounter: 30,
	// 		}
	// 	}
	// 	componentDidMount () {
	// 		const { location } = this.props
	// 		ReactPixel.init("145006083100066")
	// 		ReactPixel.track("ViewContent", location)
	// 	}
	// 	componentWillReceiveProps (nextProps) {
	// 		// this.setState({
	// 		// 	isLoading: true
	// 		// })
	// 		// console.log("nextProps", nextProps)
	// 		if (nextProps.product.qty !== this.props.product.qty) {
	// 			const { product } = nextProps
	// 			this.state = {
	// 				qty: product.qty || 1,
	// 				added: product.qty > 0
	// 			}
	// 		}
	// 	}
	// 	handleQuantity = (fn) => {
	// 		let { qty } = this.state
	// 		if (fn === "add") {
	// 			this.setState({
	// 				qty: qty + 1,
	// 				added: false
	// 			})
	// 		} else {
	// 			if (qty - 1 > 0) {
	// 				this.setState({
	// 					qty: qty - 1,
	// 					added: false
	// 				})
	// 			}
	// 		}
	// 	}
	// 	addToCart = () => {
	// 		const { product, setToCart } = this.props
	// 		const { qty } = this.state
	// 		// window.localStorage.setItem("cart", {})
	// 		let cart = JSON.parse(localStorage.getItem("cart"))
	// 		let addedProduct = {
	// 			...product,
	// 			qty: qty
	// 		}
	// 		if (!cart) {
	// 			cart = {
	// 				products: {},
	// 				totalNumber: 0
	// 			}
	// 		}
	// 		let totalNumber = 1
	// 		let bucket = {
	// 			products: {
	// 				...cart.products,
	// 				[addedProduct.id]: addedProduct
	// 			},
	// 			totalNumber: totalNumber
	// 		}
	// 		// Object.keys(cart.products).map((key) => {
	// 		// 	totalNumber = totalNumber + cart.products[key].qty
	// 		// })
	// 		// let bucket = cart ? (cart.products || {}) : {}
	// 		// console.log("cart", cart)
	// 		this.setState({
	// 			added: true
	// 		})
	// 		ReactPixel.track("AddToCart", cart)
	// 		localStorage.setItem("cart", JSON.stringify(bucket))
	// 		setToCart(bucket)
	// 		// var retrievedObject = localStorage.getItem("cart")
	// 		// console.log("cart", JSON.parse(retrievedObject))
	// 	}
	// 	render () {
	// 		const { product, region } = this.props
	// 		const { qty, added } = this.state
	// 		return (
	// 			<div className="card">
	// 				<div className="slider__content">
	// 					<Slider {...settings}>
	// 						{product.imgUrls.map((item, i) => {
	// 							return (
	// 								<div key={i} className="slider__img">
	// 									<img src={item} alt={product.productName} className="img img-responsive" />
	// 								</div>
	// 							)
	// 						})}
	// 					</Slider>
	// 				</div>
	// 				<div className="media" style={{ margin: "0" }}>
	// 					<Link to={`/products/Detail?${product.type}&${product.urlName.replace(/ /g, "-")}`}>
	// 						<div className="card__title">
	// 							{product.productName}
	// 						</div>
	// 					</Link>
	// 				</div>
	// 				<div className="row">
	// 					<div className="col-xs-5" style={{ textAlign: "left" }}>
	// 						<div className="card__qty">
	// 							Weight
	// 						</div>
	// 						<div className="card__wt">{product.netWeight}</div>
	// 					</div>
	// 					<div className="col-xs-5 pull-right" style={{ textAlign: "right" }}>
	// 						<div className="card__qty">
	// 							Price
	// 						</div>
	// 						<div className="card__price"><i className="fa fa-inr" aria-hidden="true" /> {product.mrp}</div>
	// 					</div>
	// 				</div>
	// 				{product.type !== "Dhoop" ? <RestrictedStateWiseComponent regionName={region}>
	// 					<div className="row" style={{ marginTop: "10px" }}>
	// 						<div className="col-xs-4 col-md-6">
	// 							<div className="input-group qty">
	// 								<span className="input-group-btn">
	// 									<button onClick={() => this.handleQuantity("sub")} type="button" className="quantity-left-minus btn btn-default btn-number" data-type="minus" data-field="">
	// 										<span className="glyphicon glyphicon-minus" />
	// 									</button>
	// 								</span>
	// 								<input readOnly type="text" id="quantity" name="quantity" className="form-control input-number" value={qty} min="1" max="100" />
	// 								<span className="input-group-btn">
	// 									<button onClick={() => this.handleQuantity("add")} type="button" className="quantity-right-plus btn btn-default btn-number" data-type="plus" data-field="">
	// 										<span className="glyphicon glyphicon-plus" />
	// 									</button>
	// 								</span>
	// 							</div>
	// 						</div>
	// 						<div className="col-xs-4 col-md-6">
	// 							<div className="card__btn">
	// 								{qty > 0 && added
	// 									? <Button>Added</Button>
	// 									: <Button onClick={() => this.addToCart(product)}>Add To Cart</Button>
	// 								}
	// 							</div>
	// 						</div>
	// 					</div>
	// 				</RestrictedStateWiseComponent> : null}
	// 			</div>
	// 		)
	// 	}
	// }
	
	// ProductStoreCard.propTypes = {
	// 	product: PropTypes.object,
	// 	setToCart: PropTypes.func,
	// 	isCartChange: PropTypes.bool
	// }
	
	// const mapStateToPropsView = (state, ownProps) => {
	// 	const { product } = ownProps
	// 	return {
	// 		...ownProps,
	// 		product: state.addToCartList.products[product.id] || product,
	// 		region: state.ipData.region || "delhi",
	// 		isCartChange: state.addToCartList.isAddToCartChange,
	// 		// region: "XYX"
	// 	}
	// }
	
	// const mapDispatchToPropsView = dispatch => {
	// 	return {
	// 		setToCart: (bucket) => dispatch({ type: `SET_TO_CART`, addToCartList: bucket })
	// 	}
	// }
	
	// const ProductStoreCardWrapper = connect(
	// 	mapStateToPropsView,
	// 	mapDispatchToPropsView
	// )(ProductStoreCard)
	
	var DropdownMenu = function DropdownMenu(_ref) {
	  var title = _ref.title,
	      items = _ref.items,
	      handleSortBy = _ref.handleSortBy;
	
	  return _react2.default.createElement(
	    _reactBootstrap.DropdownButton,
	    { id: title, bsStyle: "Sort By:", title: "" + title },
	    items.map(function (item, i) {
	      return _react2.default.createElement(
	        _reactBootstrap.MenuItem,
	        { onClick: function onClick() {
	            return handleSortBy(item.identifier);
	          }, active: title === item.name, key: i, eventKey: i },
	        item.name
	      );
	    })
	  );
	};
	
	DropdownMenu.propTypes = {
	  title: _propTypes2.default.string,
	  items: _propTypes2.default.array,
	  handleSortBy: _propTypes2.default.func
	};
	
	var SimpleDropdownMenu = function SimpleDropdownMenu(_ref2) {
	  var title = _ref2.title,
	      items = _ref2.items,
	      handleChip = _ref2.handleChip,
	      activeChip = _ref2.activeChip;
	
	  return _react2.default.createElement(
	    _reactBootstrap.DropdownButton,
	    { id: title, bsStyle: "default", title: title },
	    items.map(function (item, i) {
	      return _react2.default.createElement(
	        "div",
	        { className: "active__chips", key: i },
	        _react2.default.createElement(
	          "div",
	          { className: "prim__tabs chip" + (item.identifier === activeChip ? "-active" : ""), onClick: function onClick() {
	              return handleChip(item.identifier);
	            }, key: i },
	          item.title
	        ),
	        item.subCategory.map(function (sCat) {
	          return _react2.default.createElement(
	            "div",
	            { style: { margin: "10px 20px" }, key: sCat.identifier },
	            _react2.default.createElement(
	              "span",
	              { onClick: function onClick() {
	                  return handleChip(sCat.identifier);
	                }, className: "sub__tabs chip" + (sCat.identifier === activeChip ? "-active" : "") },
	              sCat.title
	            )
	          );
	        })
	      );
	    })
	  );
	};
	
	SimpleDropdownMenu.propTypes = {
	  title: _propTypes2.default.string,
	  items: _propTypes2.default.array,
	  handleChip: _propTypes2.default.func,
	  activeChip: _propTypes2.default.string
	};
	
	var SortByList = [{
	  identifier: "Sort By:",
	  name: ""
	}, {
	  identifier: "low_high",
	  name: "Price: Low to High"
	}, {
	  identifier: "high_low",
	  name: "Price: High to low"
	}, {
	  identifier: "new_product",
	  name: "New Products"
	}, {
	  identifier: "most_popular",
	  name: "Most Popular"
	}];
	
	var selectableChips = [{
	  identifier: "all_spices",
	  title: "Masalas (Spices)",
	  subCategory: [{
	    identifier: "classic_range",
	    title: "Classic Range"
	  }, {
	    identifier: "mini_packs",
	    title: "Mini Pouches"
	  }, {
	    identifier: "specialities",
	    title: "Specialities"
	  }]
	}, {
	  identifier: "puja_materials",
	  title: "Puja materials",
	  subCategory: []
	}, {
	  identifier: "misc",
	  title: "Other Products",
	  subCategory: []
	}];
	
	var View = exports.View = function (_React$Component) {
	  _inherits(View, _React$Component);
	
	  function View(args) {
	    _classCallCheck(this, View);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.defaultItems = function () {
	      var listItemById = _this.props.listItemById;
	
	      _this.allMasala = [];
	      _this.classicMasala = [];
	      _this.miniPacks = [];
	      _this.specialities = [];
	      _this.pujaMaterials = [];
	      _this.miscItems = [];
	      var uniquiIds = [];
	      var miniUn = [];
	      var splUni = [];
	      var classicUni = [];
	      var allMasalaUni = [];
	
	      console.log(listItemById);
	      Object.keys(listItemById).map(function (key) {
	        var item = listItemById[key];
	        if (uniquiIds.indexOf(item.u_id) < 0) {
	          if (listItemById[key].type === "Spices") {
	            if (listItemById[key].packType === 0 && miniUn.indexOf(item.u_id) < 0) {
	              miniUn.push(item.u_id);
	              _this.miniPacks.push(listItemById[key]);
	              // this.allMasala.push(listItemById[key])
	            } else if ((listItemById[key].packType === 1 || listItemById[key].packType === 2) && classicUni.indexOf(item.u_id) < 0) {
	              classicUni.push(item.u_id);
	              _this.classicMasala.push(listItemById[key]);
	              // this.allMasala.push(listItemById[key])
	            }
	            if (listItemById[key].spl === 1 && splUni.indexOf(item.u_id) < 0) {
	              _this.specialities.push(listItemById[key]);
	              splUni.push(item.u_id);
	            }
	            if (allMasalaUni.indexOf(item.u_id) < 0) {
	              allMasalaUni.push(item.u_id);
	              _this.allMasala.push(item);
	            }
	          } else if (listItemById[key].type === "Dhoop") {
	            _this.pujaMaterials.push(listItemById[key]);
	            uniquiIds.push(item.u_id);
	          } else if (listItemById[key].type === "Misc") {
	            // console.log("listItemById[key]", listItemById[key])
	            uniquiIds.push(item.u_id);
	            _this.miscItems.push(listItemById[key]);
	          }
	        }
	      });
	    };
	
	    _this.handleFilter = function (identifier) {
	      if (!identifier || identifier === "all_spices") {
	        _this.products = [].concat(_this.allMasala);
	      } else if (identifier === "classic_range") {
	        console.log("here" + "classic range");
	        _this.products = [].concat(_this.classicMasala);
	      } else if (identifier === "mini_packs") {
	        _this.products = [].concat(_this.miniPacks);
	        console.log("here" + "minipack");
	      } else if (identifier === "specialities") {
	        _this.products = [].concat(_this.specialities);
	        console.log("here" + "specialities");
	      } else if (identifier === "puja_materials") {
	        _this.products = [].concat(_this.pujaMaterials);
	        console.log("here" + "Puja material");
	      } else if (identifier === "misc") {
	        _this.products = [].concat(_this.miscItems);
	        console.log("here" + "misc");
	      }
	      // if (this.state.activeSortBy !== "default") {
	      // 	this.handleSortBy(this.state.activeSortBy, identifier)
	      // }
	    };
	
	    _this.handleChip = function (identifier) {
	      // pushInUrl(identifier)
	      _this.setState({
	        isSearching: true,
	        activeChip: identifier,
	        activeKeyword: ""
	      });
	      _this.handleFilter(identifier);
	      // this.products = []
	      _this.refs.search__by.value = null;
	      setTimeout(function () {
	        _this.setState({
	          isSearching: false,
	          activeSortBy: "default"
	        });
	      }, 1000);
	    };
	
	    _this.handleSortBy = function (identifier, filterIdentifier) {
	      var activeChip = _this.state.activeChip;
	
	      _this.setState({
	        isSearching: true
	      });
	      var actuallSelectedChip = filterIdentifier || activeChip;
	      var prevProductList = [].concat(_this.products);
	      _this.products = [];
	      // let arr = actuallSelectedChip === "puja_materials" ? this.puja_materials
	      // 	: actuallSelectedChip === "all_spices" ? this.allMasala
	      // 		: actuallSelectedChip === "classic_range" ? this.classicMasala
	      // 			: actuallSelectedChip === "specialiaties" ? this.specialiaties
	      // 				: actuallSelectedChip === "miniPacks" ? this.miniPacks : []
	      if (identifier === "default") {
	        _this.defaultItems();
	        _this.products = [].concat(prevProductList);
	        // return
	      } else if (identifier === "low_high") {
	        [].concat(prevProductList).sort(function (a, b) {
	          return a.mrp - b.mrp;
	        }).forEach(function (item, i) {
	          return _this.products.push(item);
	        });
	      } else if (identifier === "high_low") {
	        [].concat(prevProductList).sort(function (a, b) {
	          return b.mrp - a.mrp;
	        }).forEach(function (item, i) {
	          return _this.products.push(item);
	        });
	      } else if (identifier === "most_popular") {
	        if (actuallSelectedChip === "Spices") {
	          [].concat(prevProductList).sort(function (a, b) {
	            return a.packType - b.packType;
	          }).forEach(function (item, i) {
	            return _this.products.push(item);
	          });
	        } else {
	          [].concat(prevProductList).sort(function (a, b) {
	            return a.spl - b.spl;
	          }).forEach(function (item, i) {
	            return _this.products.push(item);
	          });
	          // this.products = this.specialiaties
	        }
	      } else if (identifier === "new_product") {
	        if (actuallSelectedChip === "puja_materials" || actuallSelectedChip === "misc") {
	          [].concat(prevProductList).sort(function (a, b) {
	            return b.productName.toLowerCase().trim().search("mala") - a.productName.toLowerCase().trim().search("mala");
	          }).forEach(function (item, i) {
	            return _this.products.push(item);
	          });
	        } else {
	          [].concat(prevProductList).sort(function (a, b) {
	            return b.packType - a.packType;
	          }).forEach(function (item, i) {
	            return _this.products.push(item);
	          });
	          // this.products = this.miniPacks
	        }
	      }
	      _this.setState({
	        activeSortBy: identifier
	      });
	      setTimeout(function () {
	        _this.setState({
	          isSearching: false
	        });
	      }, 1000);
	    };
	
	    _this.handleSearch = function (e) {
	      // e.preventdefault
	      var activeChip = _this.state.activeChip;
	
	      var str = e.target.value.length ? e.target.value.toLowerCase() : "";
	      _this.setState({
	        isSearching: true,
	        activeKeyword: str
	      });
	      _this.handleFilter(activeChip);
	      _this.handleSortBy(_this.state.activeSortBy);
	      var prevProductList = [].concat(_this.products);
	      _this.products = [];
	      prevProductList.forEach(function (item) {
	        if (item.sName.toLowerCase().trim().search(str.trim()) > -1) {
	          _this.products.push(item);
	        }
	      });
	      setTimeout(function () {
	        _this.setState({
	          isSearching: false
	        });
	      }, 1000);
	    };
	
	    _this.handleKeyUp = function (e) {
	      // console.log("ref", e.keyCode)
	      var str = e.target.value.length ? e.target.value.toLowerCase() : "";
	      // setTimeout.clear()
	      if (_this.timeoutId) {
	        clearTimeout(_this.timeoutId);
	      }
	      _this.timeoutId = setTimeout(function () {
	        _reactFacebookPixel2.default.track("Search", { str: str });
	      }, 2000);
	    };
	
	    _this.SeeMoreFunction = function (e) {
	      _this.setState({
	        lastCounter: _this.state.lastCounter + 20
	      });
	    };
	
	    _this.state = {
	      lastCounter: 40,
	      activeChip: "all_spices",
	      isSearching: true,
	      activeSortBy: "default",
	      activeKeyword: "",
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	    _this.totalProducts = [].concat(_productListConstant.SpiceDetails, _productListConstant.Misc, _productListConstant.DhoopDetails);
	    _this.products = []; // Initaily
	    return _this;
	  }
	
	  View.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var query = this.props.query;
	
	    _reactFacebookPixel2.default.init("145006083100066");
	    var filter = query;
	    this.defaultItems();
	    this.handleFilter(filter);
	    this.setState({
	      activeChip: filter || "all_spices"
	    });
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        },
	        isSearching: false
	      });
	    }, 0);
	  };
	
	  View.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.setState({
	      showTrans: true,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0.1
	      },
	      isSearching: true
	    });
	  };
	
	  View.prototype.render = function render() {
	    var _this3 = this;
	
	    // const products = []
	    var _state = this.state,
	        activeChip = _state.activeChip,
	        isSearching = _state.isSearching,
	        activeSortBy = _state.activeSortBy,
	        defaultStyle = _state.defaultStyle,
	        lastCounter = _state.lastCounter;
	    var _props = this.props,
	        location = _props.location,
	        ownProps = _props.ownProps,
	        region = _props.region;
	
	    var title = "Sort by";
	    // console.log("this.miscItems", this.miscItems)
	    var selectedChipName = void 0;
	    SortByList.forEach(function (item) {
	      if (item.identifier === activeSortBy) {
	        title = item.name;
	      }
	    });
	    selectableChips.forEach(function (item) {
	      if (item.identifier === activeChip) {
	        selectedChipName = item.title;
	      } else if (item.subCategory.length) {
	        item.subCategory.forEach(function (sCat) {
	          if (sCat.identifier === activeChip) {
	            selectedChipName = sCat.title;
	          }
	        });
	      }
	    });
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "Bawa Masala Company Store | Premium Indian Spices Since 1952",
	        description: "Bawa Masala Company\u2019s whole spices, spice blends, powdered spices and speciality ingredients. Explore our full range and enquire about bulk or dealer orders.",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "global__wrapper", style: { background: "#e9eef6" } },
	        _react2.default.createElement(
	          "h1",
	          { style: { visibility: "hidden", position: "fixed" } },
	          "Bawa Masala Company Store | Premium Indian Spices Since 1952"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "store__wrapper", style: defaultStyle },
	          _react2.default.createElement(
	            "div",
	            { className: "store__content row" },
	            _react2.default.createElement(
	              "div",
	              { className: "left___content col-md-2" },
	              _react2.default.createElement(
	                "div",
	                { className: "active__chips" },
	                selectableChips.map(function (item) {
	                  return _react2.default.createElement(
	                    "div",
	                    { key: item.identifier, style: { margin: "10px 0" } },
	                    _react2.default.createElement(
	                      "div",
	                      null,
	                      _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { style: { textDecoration: "none" }, to: "/store?" + item.identifier },
	                        _react2.default.createElement(
	                          "span",
	                          {
	                            onClick: function onClick() {
	                              return _this3.handleChip(item.identifier);
	                            },
	                            className: "prim__tabs chip" + (item.identifier === activeChip ? "-active" : "")
	                          },
	                          item.title
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      "div",
	                      { className: "sub__tabs", style: { margin: "0px 0 0px 10%" } },
	                      item.subCategory.map(function (sCat) {
	                        return _react2.default.createElement(
	                          "div",
	                          { style: { margin: "10px 0" }, key: sCat.identifier },
	                          _react2.default.createElement(
	                            "span",
	                            {
	                              onClick: function onClick() {
	                                return _this3.handleChip(sCat.identifier);
	                              },
	                              className: "sub__tabs chip" + (sCat.identifier === activeChip ? "-active" : "")
	                            },
	                            sCat.title
	                          )
	                        );
	                      })
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "right__content  col-md-10" },
	              _react2.default.createElement(
	                "div",
	                { className: "region_msg" },
	                _react2.default.createElement(
	                  "i",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "We currently do not ship to Delhi, U.P., Punjab, Haryana, Uttarakhand & U.T. of Chandigarh. To place an order for these states, please visit",
	                    " ",
	                    _react2.default.createElement(
	                      "a",
	                      { href: "https://bawaindustries.com/", target: "_blank", className: "href" },
	                      "www.bawaindustries.com"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "filter__bar" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-3 col-md-3 col-xs-5" },
	                    _react2.default.createElement("input", {
	                      onKeyUp: this.handleKeyUp,
	                      type: "text",
	                      ref: "search__by",
	                      className: "search__by",
	                      onChange: function onChange(e) {
	                        return _this3.handleSearch(e);
	                      },
	                      placeholder: "Search by Name",
	                      name: "search",
	                      value: this.state.activeKeyword
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-2 col-md-2 col-xs-7  pull-right" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "sort__by  pull-right" },
	                      _react2.default.createElement(
	                        _reactBootstrap.ButtonToolbar,
	                        null,
	                        _react2.default.createElement(DropdownMenu, { handleSortBy: this.handleSortBy, title: title, activeSortBy: activeSortBy, items: SortByList })
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "row mobile-dropdown", style: { marginTop: "7px" } },
	                  _react2.default.createElement(
	                    _reactBootstrap.ButtonToolbar,
	                    null,
	                    _react2.default.createElement(SimpleDropdownMenu, { handleChip: this.handleChip, title: selectedChipName, activeChip: activeChip, items: selectableChips })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _RestrictedStateWiseComponent2.default,
	                { regionName: region },
	                _react2.default.createElement(
	                  "div",
	                  { className: "minimum_order_strip" },
	                  _react2.default.createElement(
	                    "i",
	                    null,
	                    _react2.default.createElement(
	                      "b",
	                      null,
	                      "Free shipping on orders of Rs. 500 and above"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "product__details" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "row" },
	                  isSearching ? _react2.default.createElement(
	                    "div",
	                    { style: { margin: "10% 50% 10%" } },
	                    _react2.default.createElement(_reactSpinners.ClipLoader, { color: "#19217a", loading: isSearching })
	                  ) : this.products.length ? this.products.slice(0, lastCounter).map(function (item, i) {
	                    return _react2.default.createElement(
	                      "div",
	                      { key: i, className: "col-lg-3 col-sm-6 col-md-4 col-xs-12", style: { padding: "5px" } },
	                      _react2.default.createElement(_ProductStoreCard2.default, _extends({ key: i, product: item }, ownProps))
	                    );
	                  }) : _react2.default.createElement(
	                    "div",
	                    { className: "no__product" },
	                    "No Product in the list"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "see_more" },
	                lastCounter >= this.products.length ? null : _react2.default.createElement(
	                  "div",
	                  { className: "errow_img" },
	                  _react2.default.createElement(
	                    "button",
	                    { className: "see_more_button", onClick: function onClick() {
	                        return _this3.SeeMoreFunction();
	                      } },
	                    "See More"
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return View;
	}(_react2.default.Component);
	
	View.propTypes = {
	  query: _propTypes2.default.string,
	  region: _propTypes2.default.string
	};
	
	var mapDisptchToProps = function mapDisptchToProps(dispatch, ownProps) {
	  // console.log("createHistory", browserHistory)
	  // const { push } = browserHistory
	  return {
	    // pushInUrl: (filterSt) => store.dispatch(push(`store?filter=${filterSt}`)),
	  };
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  var location = ownProps.location;
	  var products = state.products;
	
	  var query = location.search.split("?")[1];
	  return _extends({}, ownProps, {
	    query: query,
	    listItemById: products.listItemById || [],
	    region: state.ipData.region || "delhi"
	  });
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDisptchToProps)(View);

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-store-index-js-b9a2d50c91ad41ab747c.js